// import { useMemo } from "react";
import { useState } from "react"

import StakingComponent from "../components/staking/StakingComponent"
import * as anchor from "@project-serum/anchor"
// import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base"
// import {
//   getPhantomWallet,
//   getSolflareWallet,
//   getSolletWallet,
// } from "@solana/wallet-adapter-wallets";

// import {
//   ConnectionProvider,
//   WalletProvider,
// } from "@solana/wallet-adapter-react";

// import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";

// Can be set to 'devnet', 'testnet', or 'mainnet-beta'
const network = WalletAdapterNetwork.Mainnet
// You can also provide a custom RPC endpoint
//const endpoint = useMemo(() => clusterApiUrl(network), [network]);
import { ThemeProvider, createTheme } from "@material-ui/core"

const theme = createTheme({
	palette: {
		type: "dark",
	},
})
const App = () => {
	const [metrue, setMetrue] = useState(() => false)

	return (
		<ThemeProvider theme={theme}>
			<StakingComponent />
			<div className="social-links">
				{!metrue && (
					<>
						<a href=" https://dinojump.co/">
							<p style={{ color: "white", fontFamily: "rainyhearts" }}>WEB</p>
						</a>
						<a href="http://twitter.com/dinojumpnft">
							<img src="img/twitter.png" alt="" />
						</a>
					</>
				)}
				<a
					onClick={() => {
						setMetrue(() => true)
						setTimeout(() => {
							setMetrue(() => false)
						}, 4500)
					}}
				>
					<img src="/melogo.png" alt="" />
				</a>

				{metrue && (
					<div className="magiceden">
						<a href="https://www.magiceden.io/marketplace/bddj">
							<p className="option"> BABIES</p>
						</a>
						<a href="https://www.magiceden.io/marketplace/dinojumpregulardinos">
							<p className="option">DINOS</p>
						</a>
					</div>
				)}
			</div>{" "}
		</ThemeProvider>
	)
}

export default App
